import { render, staticRenderFns } from "./platformIndex.vue?vue&type=template&id=701f3968&scoped=true&"
import script from "./platformIndex.vue?vue&type=script&lang=js&"
export * from "./platformIndex.vue?vue&type=script&lang=js&"
import style0 from "./platformIndex.vue?vue&type=style&index=0&id=701f3968&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701f3968",
  null
  
)

export default component.exports